import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function OfferSection() {
  return <section className="w-full bg-navy-light py-24 px-4 relative overflow-hidden" data-id="element-104">
      {/* Glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-105" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106">
        <h2 className="text-3xl md:text-5xl font-headline font-bold text-white uppercase mb-8" data-id="element-107">
          YOUR INVESTMENT TODAY
        </h2>

        <div className="bg-navy border border-gold/20 rounded-2xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-108">
          <div className="space-y-6 mb-10 text-lg text-gray-300" data-id="element-109">
            <p data-id="element-110">
              If you try to figure this out on your own, you could spend{' '}
              <span className="text-danger font-bold line-through" data-id="element-111">
                $3,000 to $5,000
              </span>{' '}
              a year on camps that are simple "money machines."
            </p>
            <p data-id="element-112">
              The "Scholarship Pro" Method doesn't cost that. It doesn't even
              cost what you pay for a pair of mid-range cleats.
            </p>
          </div>

          <div className="bg-navy-lighter/50 rounded-xl p-8 mb-10 border border-white/5" data-id="element-113">
            <p className="text-sm text-gray-400 uppercase tracking-widest mb-2" data-id="element-114">
              One-Time Investment
            </p>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-115">
              <span className="text-4xl text-gray-500 line-through font-headline" data-id="element-116">
                $97
              </span>
              <span className="text-6xl md:text-7xl font-headline font-bold text-gold text-glow" data-id="element-117">
                $6.39 USD
              </span>
            </div>
            <p className="text-cyan text-sm font-bold animate-pulse" data-id="element-118">
              Limited-time launch price
            </p>
          </div>

          <button onClick={() => {
          trackInitiateCheckout();
          window.open('https://ebookdigital.digital//cart/47440735863033:1', '_blank');
        }} className="w-full bg-gold hover:bg-gold-light text-navy-light font-headline font-bold text-2xl px-8 py-6 rounded-lg shadow-[0_0_30px_rgba(245,166,35,0.4)] transition-all transform hover:scale-[1.02] flex items-center justify-center gap-3 uppercase mb-6" data-id="element-119">
            I want instant access to the method!
            <ArrowRight className="w-8 h-8" data-id="element-120" />
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-121">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-122" />
            Instant digital access
          </div>
        </div>
      </div>
    </section>;
}